import { useState, useEffect } from "react";
import "./BuyTickets.scss";
import { Types } from "../../../types/types";

interface BuyTicketsProps {
  event: Types | null;
  selectedTicketId?: number | null;
  selectedQuantity?: number;
  selectedTickets?: { ticket_type: number; quantity: number }[];
  onBuyTicket?: (promoCode: string | null) => void;
}

export const BuyTickets: React.FC<BuyTicketsProps> = ({
  event,
  selectedTicketId = null,
  selectedQuantity = 1,
  selectedTickets = [],
  onBuyTicket,
}) => {
  const [promoCode, setPromoCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [promoError, setPromoError] = useState("");

  // Получаем билеты для отображения
  const ticketsToShow =
    selectedTickets && selectedTickets.length > 0
      ? selectedTickets
      : selectedTicketId
      ? [{ ticket_type: selectedTicketId, quantity: selectedQuantity }]
      : [];

  const getTicketInfo = (ticket_type: number) =>
    event?.ticket_types_data?.find((t) => t.id === ticket_type);

  const baseAmount = ticketsToShow.reduce((sum, t) => {
    const info = getTicketInfo(t.ticket_type);
    return sum + (info?.price || 0) * t.quantity;
  }, 0);

  const totalTickets = ticketsToShow.reduce((sum, t) => sum + t.quantity, 0);

  useEffect(() => {
    if (promoCode.trim()) {
      const validPromo = event?.promocodes_info?.find(
        (p) => p.name.toLowerCase() === promoCode.trim().toLowerCase()
      );
      if (validPromo) {
        setDiscount(validPromo.discount);
        setPromoError("");
      } else {
        setDiscount(0);
        setPromoError("Промокод недействителен");
      }
    } else {
      setDiscount(0);
      setPromoError("");
    }
  }, [promoCode, event?.promocodes_info]);

  const calculateTotal = () => {
    if (discount > 0) {
      return baseAmount * (1 - discount / 100);
    }
    return baseAmount;
  };

  const totalAmount = calculateTotal();

  return (
    <div className="BuyTickets">
      <div className="BuyTicketsmodalContent">
        <h4 className="BuyTicketsmodalTitle">
          Билеты на концерт {event?.name || "мероприятие"}
        </h4>
        <div
          className="BuyTicketsmodalInfoTikets"
          style={{ flexDirection: "column", gap: "0" }}
        >
          {/* Заголовки */}
          <div className="BuyTicketsTableRow BuyTicketsTableHeader">
            <div className="BuyTicketsTableCell_R">Категория</div>
            <div className="BuyTicketsTableCell_C">Кол-во</div>
            <div className="BuyTicketsTableCell_C second-center-cell">
              Цена за билет
            </div>
            <div className="BuyTicketsTableCell_L">Сумма</div>
          </div>
          {/* Данные по билетам */}
          {ticketsToShow.map((t, idx) => {
            const info = getTicketInfo(t.ticket_type);
            return (
              <div className="BuyTicketsTableRow" key={t.ticket_type}>
                <div className="BuyTicketsTableCell_R">{info?.name || "-"}</div>
                <div className="BuyTicketsTableCell_C">{t.quantity} шт</div>
                <div className="BuyTicketsTableCell_C second-center-cell">
                  {info?.price ? `${info.price} ₽` : "-"}
                </div>
                <div className="BuyTicketsTableCell_L">
                  {info?.price ? `${info.price * t.quantity} ₽` : "-"}
                </div>
              </div>
            );
          })}
          {/* Скидка и итоговая сумма */}
          {discount > 0 && (
            <div className="BuyTicketsTableRow">
              <div className="BuyTicketsTableCell_R">Скидка</div>
              <div className="BuyTicketsTableCell_C">{discount}%</div>
              <div className="BuyTicketsTableCell_C second-center-cell">
                -{((baseAmount * discount) / 100).toFixed(2)} ₽
              </div>
              <div className="BuyTicketsTableCell_L"></div>
            </div>
          )}
          <div className="BuyTicketsTableRow BuyTicketsTableFooter">
            <div className="BuyTicketsTableCell_R">Итого</div>
            <div className="BuyTicketsTableCell_C">{totalTickets} шт</div>
            <div className="BuyTicketsTableCell_C second-center-cell"></div>
            <div className="BuyTicketsTableCell_L">
              {totalAmount.toFixed()} ₽
            </div>
          </div>
        </div>
        <p className="BuyTicketsmodalsubTitle">
          Если у вас есть промокод, пожалуйста введите его перед покупкой
        </p>
        <div className="BuyTicketsPromo">
          <label className="BuyTicketspromoLabel">Промокод</label>
          <input
            className={`BuyTicketspromoInput ${promoError ? "error" : ""}`}
            name="name"
            placeholder="Введите промокод"
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
          />
        </div>
        {promoError && <p className="BuyTicketsPromoError">{promoError}</p>}
      </div>
      <button
        className="BuyTicketsmodalAuthBtn"
        onClick={() => {
          const promoToSend =
            promoCode.trim() && !promoError ? promoCode : null;
          onBuyTicket?.(promoToSend);
        }}
      >
        К покупке билета
      </button>
    </div>
  );
};

export default BuyTickets;
